/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { ManagedByConsole, ManagedByBackupServer } from './components';

export interface ComputersProps {
    gridName: string;
}

export const Computers: React.FC<ComputersProps> = ({ gridName, ...restProps }) => {
    switch (gridName) {
        case ('ManagedByConsole'): return <ManagedByConsole stateId={'ProtectedDataPage.Computers'} {...restProps} />;
        case ('ManagedByBackupServer'): return <ManagedByBackupServer stateId={'ProtectedDataPage.Computers'} {...restProps} />;
        default: return null;
    }
};
